/** Serializable params for `GET /api/sox-controls` (server pagination / filters / sort). */
export type ControlsListParams = {
  page: number;
  pageSize: number;
  search: string;
  filterType: string;
  filterStatus: string;
  filterFrequency: string;
  filterSignificance: string;
  filterClassification: string;
  sortKey: string | null;
  sortDir: 'asc' | 'desc';
  auditYearId: string | null;
};

const controlsRoot = ['sox-controls'] as const;

export const controlsQueryKeys = {
  all: controlsRoot,
  list: (params: ControlsListParams) => [...controlsRoot, 'list', params] as const,
  dashboard: () => [...controlsRoot, 'dashboard'] as const,
  detail: (controlId: string) => [...controlsRoot, 'detail', controlId] as const,
} as const;
